import { Input } from '@on3/ui-lib/components/Input/Input';
import { filterNumber } from '@on3/ui-lib/utils/filters';
import { VitalsHeight } from '@public/components/Elite/Profile/Edits/Vitals/Height';
import { ProfileDetailsContext } from '@public/components/Modals/Player/Details';
import { useContext } from 'react';

import styles from './DetailsVitals.module.scss';

export const DetailsVitals = () => {
  const { values, errors, handleUpdate } = useContext(ProfileDetailsContext);

  return (
    <div className={styles.block}>
      <VitalsHeight
        error={errors['height.value']}
        handleUpdate={(v) => handleUpdate('height.value', v)}
        label="Height"
        value={values.height.value}
      />
      <Input
        error={errors['weight.value']}
        label="Weight"
        name="weight"
        onChange={(e) =>
          handleUpdate('weight.value', filterNumber(e.target.value))
        }
        step="0.1"
        suffix="lbs"
        type="number"
        value={values.weight.value ?? ''}
      />
    </div>
  );
};
